import { messageDataParse } from "./messageDataParse";
import { openStats } from "./openStats";
import { setSelectedMatchday } from "./setSelectedMatchday";

export const receiveMessage = (event: MessageEvent) => {

    const message = messageDataParse(event.data);

    if(message.setSelectedMatchday) {
        setSelectedMatchday( message.setSelectedMatchday );

    }else if(message.openVblStats) {
        openStats( parseInt(message.openVblStats) );

    }else if(message.openVblStatsTeam && message.openVblStatsTeam[0]  && message.openVblStatsTeam[1]) {
        openStats( parseInt(message.openVblStatsTeam[0]), parseInt(message.openVblStatsTeam[1]) );

    }

    switch(message.type) {
        case 'setSelectedMatchday':
            setSelectedMatchday(message.data?.matchday);
            break;
        case 'openStats':
            openStats(message.data?.competitor1, message.data?.competitor2);
            break;
        default:
            break;
    }
}